import Overflow from './Overflow';
export default Overflow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-overflow/es/index.js
// module id = 87
// module chunks = 0